



export function setCookie(name, value, days) {
    let expires = "";
    if (days) {
        const date = new Date();
        // Przelicz dni na milisekundy: dni * 24 godziny * 60 minut * 60 sekund * 1000 milisekund
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    // Użyj encodeURIComponent dla wartości, aby obsłużyć specjalne znaki
    // SameSite=Lax jest dobrym domyślnym ustawieniem bezpieczeństwa
    document.cookie = name + "=" + (encodeURIComponent(value) || "") + expires + "; path=/; SameSite=Lax";
}

/**
 * Pobiera wartość ciasteczka o podanej nazwie.
 * @param {string} name Nazwa ciasteczka do pobrania.
 * @returns {string|null} Wartość ciasteczka lub null, jeśli nie znaleziono.
 */
export function getCookie(name) {
    const nameEQ = name + "=";
    const ca = document.cookie.split(';');
    for(let i = 0; i < ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0) {
            // Użyj decodeURIComponent, aby odkodować wartość
            return decodeURIComponent(c.substring(nameEQ.length, c.length));
        }
    }
    return null;
}






// --- Rejestracja Service Workera ---
const PATH = '/service-worker.js';
if ('serviceWorker' in navigator) {
    navigator.serviceWorker.register(PATH).then(function () {
        // console.log('Service Worker Registered'); // Opcjonalny log
    }).catch(function (err) {
        // console.error('Service Worker registration failed:', err); // Opcjonalny log błędu
    });
}

// --- Funkcje Nawigacji ---
function openNav() {
    const sidenav = document.getElementById("mySidenav");
    if (sidenav) {
        sidenav.style.width = "100%";
    }
}

function closeNav() {
    const sidenav = document.getElementById("mySidenav");
    if (sidenav) {
        sidenav.style.width = "0";
    }
}

// --- Detekcja Urządzeń Mobilnych ---
function isMobile() {
    // Użycie `navigator.userAgentData.mobile` jest nowsze, ale nie wszędzie wspierane
    // return navigator.userAgentData?.mobile ?? /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
    // Bezpieczniejsza, starsza metoda:
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent);
}

// --- Obsługa Zdarzeń po Załadowaniu DOM ---
document.addEventListener('DOMContentLoaded', function () {

    // --- Obsługa Ciasteczek ---
    const cookieName = "scrabble_cookies_ok";
    const cookieWarn = document.getElementById("cookie-warn");
    const closeCookieWarn = document.getElementById("close-cookie-warn");

    if (closeCookieWarn && cookieWarn) {
        closeCookieWarn.addEventListener('click', function () {
            setCookie(cookieName, '1', 365);
         
            cookieWarn.style.display = "none";
        });
    }

    const scrabbleCookie = getCookie(cookieName);

    if (scrabbleCookie !== "1" && cookieWarn) {
        setTimeout(() => {
            cookieWarn.style.display = 'block'; // lub 'flex', etc. zależnie od stylu
        }, 2000);
    }

    // --- Obsługa Klawisza Escape (zamykanie np. Sidenav) ---
    document.addEventListener('keyup', function (e) {
        if (e.key === 'Escape' || e.keyCode === 27) {
            // Zakładamy, że .closebtn jest wewnątrz #mySidenav i wywołuje closeNav()
            // Lepsze może być bezpośrednie wywołanie closeNav()
            // document.querySelectorAll('.closebtn').forEach(btn => btn.click());
            closeNav(); // Bezpośrednie wywołanie funkcji zamykania
        }
    });

    // --- Płynne Przewijanie dla Linków Kotwic ---
    document.querySelectorAll('a[href^="#"]').forEach(anchor => {
        anchor.addEventListener("click", function (e) {
            const href = this.getAttribute("href");
            // Upewnij się, że to link do ID na tej samej stronie, a nie tylko "#"
            if (href.length > 1 && href.startsWith('#')) {
                const targetId = href.substring(1);
                const targetElement = document.getElementById(targetId);

                if (targetElement) {
                    e.preventDefault(); // Zapobiegaj tylko jeśli element docelowy istnieje
                    targetElement.scrollIntoView({
                        behavior: "smooth"
                    });
                    // Opcjonalnie: Zaktualizuj URL bez przeładowania
                    // history.pushState(null, null, href);
                }
            }
        });
    });

    // --- Obsługa Przycisku "Do Góry" ---
    const goToTopButton = document.getElementById("goToTop");
    const mainAnchor = document.getElementById("main-anchor"); // Zakładamy istnienie kotwicy

    if (goToTopButton && mainAnchor) {
        goToTopButton.addEventListener("click", function () {
            mainAnchor.scrollIntoView({
                behavior: "smooth"
            });
        });
    }
});


// --- Obsługa Pokazywania/Ukrywania Przycisku "Do Góry" przy Przewijaniu ---
window.addEventListener("scroll", function () {
    const goToTopButton = document.getElementById("goToTop");
    if (goToTopButton) { 
        if (window.scrollY > 250) {
            goToTopButton.style.display = "block";
        } else {
            goToTopButton.style.display = "none";
        }
    }

   
    
});

